<mat-list>
<!--    <div mat-subheader>Zeiten</div>-->
    <mat-list-item *ngFor="let workDay of workDays$ | async">
        <fa-icon mat-list-icon [icon]="UserAdministrationMeta.Icon"></fa-icon>
        <div mat-line ><div [class.font-bold]="workDay.ItsMe">{{workDay.EmployeeName}}</div></div>
        <div mat-line>{{ workDay.Timespan / 1000 / 60 / 60 | number }} h</div>
        <fa-icon mat-list-icon *ngIf="!workDay.IsValid" icon="exclamation-triangle" matTooltip="Stempelungen sind fehlerhaft"></fa-icon>
    </mat-list-item>
    <mat-list-item *ngIf="(workDays$ | async | length) === 0">Keine Zeiten gestempelt</mat-list-item>
</mat-list>
<div class="theme-override my-4" [class]="UserAdministrationMeta.Theme">
    <button app-button *ngIf="preferredClockInComponent$ | async as clockInComponent" (click)="onTimeTrackerClick(clockInComponent)"><fa-icon class="icon" icon="stopwatch"></fa-icon> Zeiten Stempeln</button>
</div>
